import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Clickable pseudo that links to the public profile of the user.
 * Falls back to plain text if userId is missing.
 */
export default function UserLink({ userId, name, className = '', testId }) {
  if (!userId) {
    return <span className={className} data-testid={testId}>{name || '—'}</span>;
  }
  return (
    <Link
      to={`/u/${userId}`}
      data-testid={testId || `user-link-${userId}`}
      onClick={(e) => e.stopPropagation()}
      className={`hover:text-[#00F0FF] transition-colors ${className}`}
    >
      {name || '—'}
    </Link>
  );
}
